import { Theme, useMediaQuery } from '@mui/material';

export function useIsMobileResolution(): boolean {
  // We aren't doing SSR and this way it's much quicker
  // https://material-ui.com/components/use-media-query/#usemediaquery-query-options-matches
  return useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'), { noSsr: true });
}
